import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import DocLink from 'ui-forms-components/links/DocLink';
import { CAPTCHA_LEARN_MORE } from 'FormsCommonComponents/constants/KCSArticlePaths';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { TOGGLE_CAPTCHA_OTHER_FORM_ELEMENTS } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getLangKey = suffix => `editor.form.properties.${suffix}`;
const link = /*#__PURE__*/_jsx(DocLink, {
  path: CAPTCHA_LEARN_MORE,
  use: "link-on-dark",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: getLangKey('captchaLearnMore')
  })
});
const CaptchaToggle = ({
  captchaEnabled = false,
  captchaConfigurable = false,
  handleCaptchaSelect = () => {}
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsxs(TFlex, {
      justify: "start",
      align: "center",
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "captcha",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getLangKey('captchaLabel')
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: getLangKey('captchaTooltip'),
            options: {
              learnMoreLink: link
            }
          }),
          children: /*#__PURE__*/_jsx(InfoIcon, {
            size: "400"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Toggle, {
      size: "extra-small",
      checked: captchaEnabled,
      "data-test-id": "captcha-toggle",
      onChange: evt => {
        handleCaptchaSelect(evt);
        trackEditorInteraction(TOGGLE_CAPTCHA_OTHER_FORM_ELEMENTS, {
          value: [evt.target.checked ? 'enabled' : 'disabled']
        });
      },
      disabled: !captchaConfigurable,
      marginInlineEnd: "400"
    })]
  });
};
export default CaptchaToggle;